module.exports = __webpack_public_path__ + "img/4.db456d97.png";